<template>
  <div class="d-flex align-items-center mt-4">
    <div class="side-frame-warning mr-2"></div>
    <div>
      <span style="font-size: 14px; color: #606266">
        {{ $l('table_header_techCostSet') || '工艺工价设置' }}
      </span>
    </div>
    <div v-if="!disabled">
      <el-divider direction="vertical"></el-divider>
      <b-button size="sm" variant="outline-success" @click="$emit('add')">
        {{ $l('btn_addTech') || '新增工艺' }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
<style lang="scss" scoped>
.side-frame-warning {
  border-left: 3px solid $color-warning;
  height: 26px;
  margin: 0;
  padding: 0;
}
</style>
